// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"4b802382","502":"e8ff6b28","740":"888e46ff","926":"27ff8cd9","973":"16f0312e"}[chunkId] + ".chunk.js";
};